import { Menu } from "antd";
import { useNavigate } from "react-router-dom";
import { Auth, DataStore } from "aws-amplify";
import { useRestaurantContext } from "../../contexts/RestaurantContext";

const SideMenu = () => {
  const navigate = useNavigate();
  const { restaurant } = useRestaurantContext();

  const onClick = async (menuItem) => {
    if (menuItem.key === "signOut") {
      await Auth.signOut();
      await DataStore.clear();

      window.location.reload();
    } else {
      navigate(menuItem.key);
    }
  };

  const mainMenuItems = [
    {
      key: "/",
      label: "Ordenes",
    },
    {
      key: "menu",
      label: "Menu",
    },
    {
      key: "order-history",
      label: "Historial de Ordenes",
    },
  ];

  const menuItems = [
    ...(restaurant ? mainMenuItems : []),
    // {
    //   key: "settings",
    //   label: "Settings",
    // },
    {
      key: "signOut",
      label: "Cerrar Sesion",
      danger: "true",
    },
  ];

  return (
    <>
      {restaurant && <h1 style={{ margin: 10 }}>{restaurant.name}</h1>}
      <Menu items={menuItems} onClick={onClick} />
    </>
  );
};

export default SideMenu;
